/* bristm-ecommerce — section script (loaded only where the section renders) */
(function () {
  /* Theme editor: open the selected block's row */
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target;
    if (!item || !item.matches || !item.matches('.b-ecom__item') || item.classList.contains('is-open')) return;
    var trigger = item.querySelector('[data-b-acc-trigger]');
    if (trigger) trigger.click();
  });
})();
